import Login from 'components/login/Login';
import { trackClickResetPassword, trackClickRegistration } from 'utils/analytics/loginAnalytics';
import {
  loggedInCheck,
  login,
  setUsername,
  setPassword,
  setStartTime,
  toggleHasSelectedStayLoggedIn
} from 'actions/loginActions';
import { trackConversion } from 'utils/analytics/googleTagManager';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hashHistory } from 'react-router';
import PropTypes from 'prop-types';

/**
 * Generates new link from older link still in the wild
 * @param {String} oldHash
 * @return {String}
 */
export const getNewCreatePasswordLink = (oldHash) => {
  const matches = oldHash.match(/#\/(.*)\/([^?\/]*)/);
  const [, email, token] = matches;
  return `/reset_password/create_new_password/${email}/${token}`;
};

class LoginContainer extends React.Component {
  componentDidMount() {
    // temporary hack to redirect to create new password using old link
    if (window.location.search && window.location.search.split('=')[1] === 'update') {
      const hash = window.location.hash;
      const redirectTo = getNewCreatePasswordLink(hash);
      window.history.pushState({}, '', `${window.location.pathname}`);
      hashHistory.push(redirectTo);
    } else {
      this.props.loggedInCheck();
    }
    this.props.setStartTime();
    trackConversion();

    const usernameNode = document.getElementById('login-username-text-input');
    usernameNode.focus();
  }

  setPasswordValue = (event) => {
    this.props.setPassword(event.target.value || '');
  };
  setUsernameValue = (event) => {
    this.props.setUsername(event.target.value || '');
  };

  render() {
    const {
      errorText,
      hasSelectedStayLoggedIn,
      isLoginFetching,
      password,
      username
    } = this.props;

    return (
      <Login
        errorText={errorText}
        hasSelectedStayLoggedIn={hasSelectedStayLoggedIn}
        isLoginFetching={isLoginFetching}
        login={this.props.login}
        onClickRegistration={trackClickRegistration}
        onClickResetPassword={trackClickResetPassword}
        password={password}
        setPassword={this.setPasswordValue}
        setUsername={this.setUsernameValue}
        toggleHasSelectedStayLoggedIn={this.props.toggleHasSelectedStayLoggedIn}
        username={username} />
    );
  }
}

LoginContainer.propTypes = {

  // Error text in response to an unsuccessfully login attempt
  errorText: PropTypes.string,

  // Boolean that determines whether the user has selected the "Stay Logged In" checkbox or not
  hasSelectedStayLoggedIn: PropTypes.bool.isRequired,

  // Boolean that determines if the request to login is in progress
  isLoginFetching: PropTypes.bool.isRequired,

  // Check if the user is already logged in
  loggedInCheck: PropTypes.func.isRequired,

  // User calls login API call
  login: PropTypes.func.isRequired,

  // User's inputed password
  password: PropTypes.string.isRequired,

  // Password's textinput's onChange function
  setPassword: PropTypes.func.isRequired,

  // Records the time after the login page has mounted
  setStartTime: PropTypes.func.isRequired,

  // Username's textinput's onChange function
  setUsername: PropTypes.func.isRequired,

  // Click handler that toggles the hasSelectedStayLoggedIn bool
  toggleHasSelectedStayLoggedIn: PropTypes.func.isRequired,

  // User's inputed username
  username: PropTypes.string.isRequired

};

function mapStateToProps(state) {
  return {
    errorText: state.login.errorText,
    hasSelectedStayLoggedIn: state.login.hasSelectedStayLoggedIn,
    isLoginFetching: state.login.isFetching,
    password: state.login.password,
    username: state.login.username
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      loggedInCheck,
      login,
      setPassword,
      setStartTime,
      setUsername,
      toggleHasSelectedStayLoggedIn
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
